import { render, staticRenderFns } from "./CommonFooter.vue?vue&type=template&id=45115ed8&scoped=true&"
import script from "./CommonFooter.vue?vue&type=script&lang=js&"
export * from "./CommonFooter.vue?vue&type=script&lang=js&"
import style0 from "./CommonFooter.vue?vue&type=style&index=0&id=45115ed8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45115ed8",
  null
  
)

export default component.exports